import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import MultiDropDownWrapper from '../MultiDropDownWrapper/MultiDropDownWrapper';
import BaseSelect from 'components/common/BaseSelect/BaseSelect';

class MultiDropDownAsync extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      inputValue: '',
    };
  }

  setStateSave(state, callback) {
    if (this._isMounted) {
      this.setState(state, callback);
    }
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onLoad = async () => {
    if (this.props.nextPageExist) {
      this.setStateSave({ isLoading: true });
      await this.props.onLoad();
      this.setStateSave({ isLoading: false });
    }
  };

  onInputChange = debounce((value) => {
    const possibleMatch = this.props.options.findIndex((option) => option.label.toLowerCase().includes(value)) !== -1;

    const asyncInputChange = async () => {
      if (value !== this.state.inputValue) {
        this.setStateSave({ inputValue: value, isLoading: true });
        await this.props.onInputChange(value);
        this.setStateSave({ isLoading: false });
      }
    };

    if (!possibleMatch) {
      asyncInputChange();
    }
  }, 750);

  onChange = async (option) => {
    this.props.onChange(option);
    this.setStateSave({ inputValue: '', isLoading: true });
    await this.props.onInputChange('');
    this.setStateSave({ isLoading: false });
  };

  render() {
    const { selectedIdList, styles } = this.props;

    return (
      <MultiDropDownWrapper {...this.props}>
        <BaseSelect
          defaultSelect={false}
          isMulti
          blurInputOnSelect
          closeMenuOnSelect
          isDisabled={this.props.disabled}
          isClearable={this.props.clearable != null ? this.props.clearable : true}
          label={this.props.label}
          value={selectedIdList}
          placeholder={this.props.placeholder || 'All'}
          noOptionsMessage={() => (this.state.isLoading ? 'Loading...' : 'No results found')}
          isLoading={this.state.isLoading || this.props.isLoading}
          options={this.props.options}
          onChange={this.onChange}
          onMenuScrollToBottom={this.onLoad}
          onInputChange={this.onInputChange}
          styles={styles}
          cacheOptions
        />
      </MultiDropDownWrapper>
    );
  }
}

export default MultiDropDownAsync;
